import { format } from 'date-fns';
import { enGB, lt } from 'date-fns/locale';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

export function fDate(date: InputValue, locale = 'en', newFormat?: string) {
    const fm = newFormat || 'yyyy-MMM-dd';

    return date ? format(new Date(date), fm, { locale: locale === 'lt' ? lt : enGB }) : '';
}

export function isToday(date: Date) {
    const today = new Date();
    return (
        today.getDate() === date.getDate() &&
        today.getMonth() === date.getMonth() &&
        today.getFullYear() === date.getFullYear()
    );
}

export function isDateLessThanOrEqual(date1: Date, date2: Date): boolean {
    return (
        date1.getFullYear() < date2.getFullYear() ||
        (date1.getFullYear() === date2.getFullYear() &&
            (date1.getMonth() < date2.getMonth() ||
                (date1.getMonth() === date2.getMonth() && date1.getDate() <= date2.getDate())))
    );
}

export function convertDateToString(date: Date) {
    return format(date, 'yyyy-MM-dd');
}

export function convertDateToUTCString(date: Date) {
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

export function convertStringToDate(date: string | null) {
    if (!date) {
        return null;
    }
    return new Date(date);
}

export function convertTimeToDate(time: string | null) {
    if (!time) {
        return null;
    }
    const [hours, minutes] = time.split(':');
    return new Date(0, 0, 0, Number(hours), Number(minutes));
}

export function convertDateToTime(date: Date | null) {
    if (!date) {
        return null;
    }
    return format(date, 'HH:mm');
}
